<template>
	<div class="system">
		<layout width="200px">
			<template v-slot:left>
				<publicMenu :list="list" iconUrl="list"></publicMenu>
			</template>
			<template v-slot:right>
				<router-view></router-view>
			</template>
		</layout>
	</div>
</template>

<script>
import layout from '../../components/layout.vue'
import publicMenu from '../../components/publicMenu.vue'

export default {
	watch: {
		"$route"(val) {
			console.log(888888888888888);
			console.log(val);
			// this.getPath()
		}
	},
	data() {
		return {
			list: [],
			name: "",
		}
	},
	components: {
		layout,
		publicMenu,
	},
	methods: {
		getPath() {
			let path = this.$route.path
			if (path == "/index/apartment/applyCheckIn") {
				this.name = "人才信息"
			}
		},
		getAll() {
			let t = localStorage.getItem("cd");
			if (t) {
				var a = JSON.parse(t)
				console.log(a)
				a.forEach(val => {
					if (val.meta.title == '公寓') {
						var b = val.children
						console.log(b)
						this.list = b
						console.log(this.list)
					}
				})
			}
			let path = this.$route.path
			if (path == '/index/apartment') {
				this.$router.push({
					name: this.list[0].children[0].meta.title
				})
			} else {
				this.$router.push({
					path: path
				})
			}


		}
	},
	mounted() {
		this.getPath()
		this.getAll()

		// this.$http.get(
		// 	`/api/flow/flowable/task/todoList?pageNum=1&pageSize=10000&name=&category=null&processKey=`).then(res => {
		// 		console.log(res)
		// 		if (res.data.code == "200") {
		// 			res.data.data.records.forEach(element => {
		// 				if (element.procDefName == "家政服务" || element.procDefName == "公寓报修申请") {
		// 					let data = {
		// 						comment: "无",
		// 						defaultTaskShow: true,
		// 						delegateTaskShow: false,
		// 						instanceId: element.instanceId,
		// 						multiple: false,
		// 						procInsId: element.procInsId,
		// 						returnTaskShow: false,
		// 						sendUserShow: true,
		// 						targetKey: "",
		// 						taskId: element.taskId
		// 					}
		// 					this.$http.post("/api/flow/flowable/task/complete", {
		// 						...data
		// 					}).then(response => {
		// 					});

		// 				}

		// 			});
		// 		}
		// 	})
	}
}
</script>

<style scoped="scoped">

</style>
